import { clsx } from 'clsx'
import type { KycStatus } from '../queries'
import styles from './IdentityHeader.module.css'

type IdentityHeaderProps = {
  fullName: string | null
  displayName: string
  email: string | undefined
  kycStatus: KycStatus
}

function initials(name: string): string {
  const parts = name.trim().split(' ').filter(Boolean)
  if (parts.length === 0) return '?'
  return parts.slice(0, 2).map((w) => w[0]?.toUpperCase() ?? '').join('')
}

export function IdentityHeader({ fullName, displayName, email, kycStatus }: IdentityHeaderProps) {
  const name = fullName ?? displayName
  const verified = kycStatus === 'COMPLETE'

  return (
    <div className={styles.identity}>
      <div className={styles.avatar} aria-hidden="true">{initials(name)}</div>
      <div className={styles.info}>
        <div className={styles.name}>{name}</div>
        {email && <div className={styles.email}>{email}</div>}
      </div>
      <span className={clsx(styles.chip, verified ? styles.verified : styles.pending)}>
        <span className={styles.dot} aria-hidden="true" />
        {verified ? 'Verificado' : 'Verificação pendente'}
      </span>
    </div>
  )
}
